import { IntlShape } from 'react-intl';
import { createSelector } from 'reselect';

import { getCanEditLesson, getDescription } from 'common.components/lesson/selectors';
import { DEFAULT_DESCRIPTION_ID } from 'common.components/lesson/typings';
import { intlSelector } from 'utils/selectors/selectors';

export const getLessonDescriptionOrDefault = createSelector(
    [getDescription, getCanEditLesson, intlSelector],
    (description: string, canEditLesson: boolean, intl: IntlShape) => {
        if (!canEditLesson) {
            return description;
        }

        return description || intl.formatMessage({ id: DEFAULT_DESCRIPTION_ID });
    }
);

export const getIsDescriptionEmpty = createSelector(
    [getDescription],
    (description: string): boolean => description === ''
);
